import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters([
      "canUseAnalytics",
      "canAccessPersonalWorkspace",

      "isOrgOwner",
      "isOrgUser",
      "isOrgMember",

      "isTeamAdminInAnyTeam",
      "isTeamMemberInAnyTeam",
      "isTeamViewerInAnyTeam",

      "isTeamAdminInCurrentTeam",
      "isTeamMemberInCurrentTeam",
      "isTeamViewerInCurrentTeam",

      "organization",
      "organizationTeam",
      "organizationTeams",

      "settingOrganizationLinks",
      "settingTeamsLinks",

      "shouldShowOrgSettings",
      "shouldShowTeamSettings",
      "statsDatetime",

      "tinyurl",

      "user",
      "isUserLoggedIn",
    ]),

    canCreateTinyurl() {
      if (this.inOrganization) {
        return (
          this.isUserAuthorized("supervisor") ||
          this.isTeamAdminInAnyTeam ||
          this.isTeamMemberInAnyTeam
        );
      }

      return this.canUseAnalytics;
    },

    isAliasPersonal() {
      return this.requestView == "alias-personal";
    },

    isInOrgSettings() {
      const routeNames = [
        "org.settings.profile",
        "org.settings.profile.users",
        "org.settings.profile.roles",
        "org.settings.profile.sso",
        "org.settings.profile.domains",
        "org.settings.profile.subscription",
        "org.settings.profile.subscription.success",
        "org.settings.profile.subscription.cancel",
        "org.settings.profile.subscription.update",
        "org.settings.profile.payment",
      ];

      return routeNames.includes(this.$route.name);
    },

    isInOrgTeamSettings() {
      const routeNames = [
        "org.settings.teams",
        "org.settings.teams.members",
        "org.settings.teams.domains",
        "org.settings.teams.api",
      ];

      return routeNames.includes(this.$route.name);
    },

    inOrganization() {
      return this.isUserLoggedIn && "org" in this.$route.params;
    },

    inOrganizationTeam() {
      return this.inOrganization && "team" in this.$route.params;
    },

    routeOrg() {
      return this.$route.params.org || "";
    },

    routeTeam() {
      return this.$route.params.team || "";
    },

    requestView() {
      const route = this.$route;

      if ("alias" in route.query) {
        const alias = this.tinyurl?.aliases.find((a) => a.is_main);

        return "team" in alias ? "alias-team" : "alias-personal";
      } else if ("tag" in route.query) {
        return "tag";
      } else {
        if (route.name == "org.dashboard") return "dashboard-main";
        if (route.name == "org.me") return "dashboard-personal";
        if (route.name == "org.team") return "dashboard-team";
      }
    },
  },

  methods: {
    orgRequestUrl(path) {
      const route = this.$route;
      let url = "organization/{org}";

      if (this.requestView === "dashboard-main") {
        url = this.$buildUrl(`${url}/${path}`, {
          org: route.params.org,
        });
      } else if (this.requestView === "dashboard-personal") {
        url = this.$buildUrl(`${url}/personal/${path}`, {
          org: route.params.org,
        });
      } else if (this.requestView === "dashboard-team") {
        url = this.$buildUrl(`${url}/team/{team}/${path}`, {
          org: route.params.org,
          team: route.params.team,
        });
      } else if (this.requestView === "alias-team") {
        const alias = this.tinyurl.aliases.find((t) => t.is_main);

        url = this.$buildUrl(`${url}/team/{team}/${path}`, {
          org: alias.organization?.slug || route.params.org,
          team: alias.team.slug,
        });
      } else if (this.requestView === "alias-personal") {
        const alias = this.tinyurl.aliases.find((t) => t.is_main);

        url = this.$buildUrl(`${url}/personal/${path}`, {
          org: alias.organization?.slug || route.params.org,
        });
      } else if (this.requestView === "tag") {
        if (this.inOrganizationTeam) {
          url = this.$buildUrl(`${url}/team/{team}/${path}`, {
            org: route.params.org,
            team: route.params.team,
          });
        } else {
          url = this.$buildUrl(`${url}/${path}`, {
            org: route.params.org,
          });
        }
      } else {
        url = this.$buildUrl(`${url}/${path}`, {
          org: route.params.org,
        });
      }

      return url;
    },
    updateTinyurlRequestUrl(path) {
      const alias = this.tinyurl?.aliases.find((a) => a.is_main);
      let url;

      if (alias.team?.slug) {
        url = this.$apiUrl(`organization/{o}/team/{t}`, {
          o: alias.organization.slug,
          t: alias.team.slug,
        });
      } else {
        url = this.$apiUrl(`organization/{o}/personal`, {
          o: alias.organization.slug,
        });
      }

      return `${url}/${path}`;
    },

    redirectToOrgSettings() {
      if (this.settingOrganizationLinks.length) {
        const link = this.settingOrganizationLinks[0].link;

        this.$router
          .push({
            name: link,
            params: { org: this.organization.slug },
          })
          .catch(() => {});
      }
    },
    redirectToTeamSettings() {
      if (this.settingTeamsLinks.length) {
        const link = this.settingTeamsLinks[0].link;

        this.$router
          .push({
            name: link,
            params: { org: this.organization.slug },
          })
          .catch(() => {});
      }
    },
  },
};
